export enum AssetLoadManagementFilterTypeEnum {
    // PROPPANT = 'Proppant',
    // LOADING_FACILITY = 'Loading Facility',
    DRIVER = 'Driver',
    CARRIER = 'Carrier',
    // LOAD_STATUS = 'Load Status',
    REGION = 'Region',
    // DISTRICT = 'District',
    // CUSTOMER = 'Customer',
    // JOB_STATUS = 'Job Status',
    EQUIPMENT = 'Equipment',
    EQUIPMENTTYPE = 'Equipment Type',
    TRAILER = 'Trailer Type',
    LOADTYPE = 'Load Type',
    JOB = 'Job Name',
    STATUS = 'Load Status',
    // COMPLIANT_STATUS = 'CompliantStatus',
}
